import snakecaseKeys from 'snakecase-keys';
import { GoogleProtobufAny, CosmosGovV1Beta1Tx, CosmosGovV1Beta1Gov, CosmosBaseV1Beta1Coin, } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgSubmitTextProposal extends MsgBase {
    static fromJSON(params) {
        return new MsgSubmitTextProposal(params);
    }
    toProto() {
        const { params } = this;
        const depositParams = CosmosBaseV1Beta1Coin.Coin.create();
        depositParams.denom = params.deposit.denom;
        depositParams.amount = params.deposit.amount;
        const content = this.getContent();
        const proposalType = '/cosmos.gov.v1beta1.TextProposal';
        const contentAny = GoogleProtobufAny.Any.create();
        contentAny.typeUrl = proposalType;
        contentAny.value = CosmosGovV1Beta1Gov.TextProposal.encode(content).finish();
        const message = CosmosGovV1Beta1Tx.MsgSubmitProposal.create();
        message.content = contentAny;
        message.initialDeposit = [depositParams];
        message.proposer = params.proposer;
        return CosmosGovV1Beta1Tx.MsgSubmitProposal.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/cosmos.gov.v1beta1.MsgSubmitProposal',
            ...proto,
        };
    }
    toAmino() {
        const { params } = this;
        const messageWithProposalType = snakecaseKeys({
            content: {
                type: 'cosmos-sdk/TextProposal',
                value: this.getContent(),
            },
            initial_deposit: [
                {
                    denom: params.deposit.denom,
                    amount: params.deposit.amount,
                },
            ],
            proposer: params.proposer,
        });
        return {
            type: 'cosmos-sdk/MsgSubmitProposal',
            value: messageWithProposalType,
        };
    }
    toWeb3Gw() {
        const { params } = this;
        const messageWithProposalType = {
            content: {
                '@type': '/cosmos.gov.v1beta1.TextProposal',
                ...this.getContent(),
            },
            initial_deposit: [
                {
                    denom: params.deposit.denom,
                    amount: params.deposit.amount,
                },
            ],
            proposer: params.proposer,
        };
        return {
            '@type': '/cosmos.gov.v1beta1.MsgSubmitProposal',
            ...messageWithProposalType,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/cosmos.gov.v1beta1.MsgSubmitProposal',
            message: proto,
        };
    }
    toBinary() {
        return CosmosGovV1Beta1Tx.MsgSubmitProposal.encode(this.toProto()).finish();
    }
    getContent() {
        const { params } = this;
        const content = CosmosGovV1Beta1Gov.TextProposal.create();
        content.title = params.title;
        content.description = params.description;
        return CosmosGovV1Beta1Gov.TextProposal.fromPartial(content);
    }
}
